import React from 'react';

const InvoiceRow = ({ dataRow }) => {
    return (
        <tr>{dataRow}</tr>
    );
};

export default InvoiceRow;